import { Navigate, Route, Routes } from 'react-router';
import { usePermissions } from '../../lib/session';
import { LockedPage } from '../../shell/ModulePages';
import { ListDetailPage } from './lists/ListDetailPage';
import { ListsPage } from './lists/ListsPage';
import { DialerSessionPage } from './session/DialerSessionPage';
import { DialerStartPage } from './start/DialerStartPage';
import { PreviewPage } from './start/PreviewPage';
import { StatisticsPage } from './statistics/StatisticsPage';

/**
 * `/dialer/*` (PLAN §8.3): Einstieg (01), Vorschau / keine wählbaren Kontakte (02/03), the session (08–11), the
 * lists (04–07) and the setter statistics (Controlling 05). Without the dialer tool the shell's locked page;
 * the statistics follow `controlling.figures` (docs/dev/api-dialer.md „Access").
 */
export function DialerModule() {
  const permissions = usePermissions();
  const dialer = permissions.tool('dialer') === 'ok';
  const figures = permissions.has('controlling.figures');
  return (
    <Routes>
      <Route index element={dialer ? <DialerStartPage /> : <LockedPage tool="dialer" />} />
      <Route path="preview/:listId" element={dialer ? <PreviewPage /> : <LockedPage tool="dialer" />} />
      <Route path="session/:id" element={dialer ? <DialerSessionPage /> : <LockedPage tool="dialer" />} />
      <Route path="lists" element={dialer ? <ListsPage /> : <LockedPage tool="dialer" />} />
      <Route path="lists/:id" element={dialer ? <ListDetailPage /> : <LockedPage tool="dialer" />} />
      <Route path="statistics" element={figures ? <StatisticsPage /> : <LockedPage tool="dialer" />} />
      <Route path="*" element={<Navigate to="/dialer" replace />} />
    </Routes>
  );
}
